
import React from "react";
import { Building } from "lucide-react";
import {
  Accordion
} from "@/components/ui/accordion";
import FAQItem from "./FAQItem";

const AboutCompanyFAQ = () => {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-semibold mb-4 theme-primary-text flex items-center">
        <Building className="h-5 w-5 mr-2" />
        Về Công Ty Chúng Tôi
      </h3>
      <Accordion type="single" collapsible className="space-y-4">
        <FAQItem 
          value="item-6"
          icon={Building}
          question="Công ty của bạn đã quản lý bất động sản bao lâu?"
          answer="Đội ngũ sáng lập của chúng tôi có nhiều năm kinh nghiệm chuyên sâu trong lĩnh vực quản lý và vận hành bất động sản cho thuê tại TP.HCM. Propico tập trung thiết lập quy trình quản lý tinh gọn, hiện đại và chuẩn mực cao, hướng tới mục tiêu đồng hành cùng hàng trăm chủ nhà căn hộ lẻ tại các quận trung tâm TP.HCM."
        />
        <FAQItem 
          value="item-8"
          icon={Building}
          question="Điều gì thúc đẩy các nhà sáng lập bắt đầu công ty này?"
          answer="Các nhà sáng lập của chúng tôi là chủ sở hữu bất động sản, những người đã trải nghiệm trực tiếp những thách thức của quản lý cho thuê—thu nhập không thể đoán trước, rắc rối bảo trì và vấn đề khách thuê. Sau khi tìm kiếm giải pháp và chỉ tìm thấy các dịch vụ phân mảnh với chi phí ẩn, họ quyết định tạo ra dịch vụ quản lý bất động sản toàn diện mà họ mong muốn tồn tại. Propico được xây dựng bởi chủ nhà cho chủ nhà, kết hợp công nghệ với dịch vụ cá nhân hóa để giải quyết các vấn đề thực sự mà chủ sở hữu bất động sản phải đối mặt hàng ngày."
        />
      </Accordion>
    </div>
  );
};

export default AboutCompanyFAQ;
